export default __webpack_public_path__ + "static/media/residencial_12.3165f8dc.png";